/**
 * Enum for SMS error codes
 */
export const SMS_ERROR_CODE = {
  /**
   * '2102': 同一个验证码错误三次, 需重发验证码验证
   */
  REACH_INVALID_LIMIT: '2102',
  COMMON_ERROR: '1015'
};

/**
 * Custom error class for SMS-related errors
 */
export class SmsError extends Error {
  static defaultErrorMessage = 'Y9052';
  
  constructor(code, message) {
    super();
    this.code = code;
    this.message = message || `E${this.code}`;

    // Set the prototype explicitly
    Object.setPrototypeOf(this, SmsError.prototype);
  }
}

export const reachInvalidLimitError = new SmsError(SMS_ERROR_CODE.REACH_INVALID_LIMIT);
